import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logos/logo3.png'


const _hoisted_1 = { class: "content d-flex justify-content-center align-items-center" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body p-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-3 mx-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    border: "0",
    alt: "",
    class: "img-fluid"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-muted text-center mb-3" }, " Bitte geben Sie Ihre Benutzerdaten ein. Diese Daten haben Sie nach Ihrer Anmeldung per E-Mail erhalten. Bitte beachten Sie die Gross- und Kleinschreibung. ", -1)
const _hoisted_6 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-user text-muted" })
], -1)
const _hoisted_8 = { class: "form-group form-group-feedback form-group-feedback-left" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = ["type"]
const _hoisted_11 = { class: "input-group-append" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-control-feedback" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon-lock text-muted" })
], -1)
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "login-form",
      onKeyup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.checkForEnter && _ctx.checkForEnter(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              type: "text",
              tabindex: "1",
              placeholder: "Benutzername",
              autocomplete: "off",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
            }, null, 512), [
              [_vModelText, _ctx.username]
            ]),
            _hoisted_7
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: _ctx.protectPassword?'password':'text',
                tabindex: "2",
                class: "form-control",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                placeholder: "Passwort"
              }, null, 8, _hoisted_10), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("span", _hoisted_11, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.protectPassword=!_ctx.protectPassword))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fal", _ctx.protectPassword?'fa-eye':'fa-eye-slash'])
                  }, null, 2)
                ])
              ])
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", {
              class: "btn btn-primary btn-lg btn-block",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
              tabindex: "3"
            }, "Login")
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("a", {
              href: "",
              class: "text-muted",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)))
            }, "Passwort vergessen")
          ])
        ])
      ])
    ], 32)
  ]))
}